export function getPanelId(baseId: string | undefined) {
  return baseId ? `${baseId}-panel` : undefined;
}

export function getLabelId(baseId: string | undefined) {
  return baseId ? `${baseId}-label` : undefined;
}
